export declare type LoadTicketMode =
  | 'INIT'
  | 'INTERVAL'
  | 'AFTER_UPLOAD_FILE';

/**
 * files related that are here belong to the ticket
 * so it updates ticket's data in the store
 */
export const ticketConstants = {
  LOAD_TICKET_REQUEST: 'LOAD_TICKET_REQUEST',
  LOAD_TICKET_SUCCESS: 'LOAD_TICKET_SUCCESS',
  LOAD_TICKET_ERROR: 'LOAD_TICKET_ERROR',

  TRIGGER_PREPROCESS_REQUEST: 'TRIGGER_PREPROCESS_REQUEST',
  TRIGGER_PREPROCESS_SUCCESS: 'TRIGGER_PREPROCESS_SUCCESS',
  TRIGGER_PREPROCESS_ERROR: 'TRIGGER_PREPROCESS_ERROR',

  DELETE_FILES_REQUEST: 'DELETE_FILES_REQUEST',
  DELETE_FILES_SUCCESS: 'DELETE_FILES_SUCCESS',
  DELETE_FILES_ERROR: 'DELETE_FILES_ERROR',

  UPDATE_FILES_RECYCLE_STATUS_REQUEST:
    'UPDATE_FILES_RECYCLE_STATUS_REQUEST',
  UPDATE_FILES_RECYCLE_STATUS_SUCCESS:
    'UPDATE_FILES_RECYCLE_STATUS_SUCCESS',
  UPDATE_FILES_RECYCLE_STATUS_ERROR:
    'UPDATE_FILES_RECYCLE_STATUS_ERROR',

  SUBMIT_BOOKING_REQUEST: 'SUBMIT_BOOKING_REQUEST',
  SUBMIT_BOOKING_SUCCESS: 'SUBMIT_BOOKING_SUCCESS',
  SUBMIT_BOOKING_ERROR: 'SUBMIT_BOOKING_ERROR',

  PREVIEW_BOOKING_REQUEST: 'PREVIEW_BOOKING_REQUEST', // preview merged file
  PREVIEW_BOOKING_SUCCESS: 'PREVIEW_BOOKING_SUCCESS',
  PREVIEW_BOOKING_ERROR: 'PREVIEW_BOOKING_ERROR',

  SAVE_TICKET_REQUEST: 'SAVE_TICKET_REQUEST',
  SAVE_TICKET_SUCCESS: 'SAVE_TICKET_SUCCESS',
  SAVE_TICKET_ERROR: 'SAVE_TICKET_ERROR',

  UPDATE_FORM_TICKET_AT_KEY: 'UPDATE_FORM_TICKET_AT_KEY',
  SET_FORM_TICKET: 'SET_FORM_TICKET',
  UPDATE_TICKET_ATT: 'UPDATE_TICKET_ATT',
  UPDATE_TICKET_ATTACHMENTS: 'UPDATE_TICKET_ATTACHMENTS',
  UPDATE_TICKET_FILE_STATUS: 'UPDATE_TICKET_FILE_STATUS',

  UPDATE_SI: 'UPDATE_TICKET_SI',
  RESET_TICKET: 'RESET_TICKET',
  UPDATE_TICKET_ASSIGNEE: 'UPDATE_TICKET_ASSIGNEE',
  REMOVE_TICKET_ASSIGNEE: 'REMOVE_TICKET_ASSIGNEE',

  MERGE_TO_TICKET: 'MERGE_TO_TICKET',

  SUBMIT_BOOKING_STOP_LOADING: 'SUBMIT_BOOKING_STOP_LOADING',
  SET_AUTO_MARK_IS_SPLIT_ERROR_TXT:
    'SET_AUTO_MARK_IS_SPLIT_ERROR_TXT',

  UPDATE_ATTACHMENTS: 'UPDATE_ATTACHMENTS',

  SET_CHECKING_BOOKING_INFO: 'SET_CHECKING_BOOKING_INFO',

  CACHE_ON_LOAD_FORM_TO_AUTOSAVE_API_DATA:
    'CACHE_ON_LOAD_FORM_TO_AUTOSAVE_API_DATA',
  CACHE_ON_LOAD_IS_UNASSIGNED: 'CACHE_ON_LOAD_IS_UNASSIGNED',
};
